export default "__VITE_ASSET__NujaaHrs__"